export default __webpack_public_path__ + "static/dashboard-13ae3ebd62cb11fd43520bc19754d80e.png";